import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";
import { PrintTemplateType } from "../components/ChecklistV2/Types";

export type printTemplate = {
  id?: string,
  name: string | null;
  dafaultTemplate?: boolean;
  cliente?: string | null;
  headerText?: {
    bold?: boolean;
    italic?: boolean;
    size?: number | null;
    text?: string | null;
  };
  footerText?: {
    bold?: boolean | null;
    italic?: boolean;
    size?: number | null;
    text?: string | null;
  };
  color?: string | null;
  logo: File | string | null;
  status: boolean;
};

class PrintService {


  getAllTemplates = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/printTemplate/getAll",
        {
          ...body,
        }
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  createPrintTemplate = async (
    body: AuthBodyType,
    printTemplate: printTemplate
  ) => {
    try {
      const data: AxiosResponse = await api.post("/printTemplate/create",
        {
          ...body,
          printTemplate,
        }
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  editPrintTemplate = async (
    body: AuthBodyType,
    printTemplate: PrintTemplateType,
    id: string,
  ) => {
    try {
      const data: AxiosResponse = await api.post("/printTemplate/edit",
        {
          ...body,
          printTemplate,
          id,
        }
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  getByClient = async (
    body: AuthBodyType,
    clientId: string
  ) => {
    try {
      const data: AxiosResponse = await api.post("/printTemplate/getByClient",
        {
          ...body,
          clientId
        }
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };
}

export default PrintService;
